if (!customElements.get('weekly-restock-countdown')) {
  customElements.define('weekly-restock-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.anchor = Date.parse(this.dataset.restockDate);
      this.weekly = this.dataset.weekly === 'true';
      if (!Number.isFinite(this.anchor)) {
        this.hidden = true;
        return;
      }
      this.update();
      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    update() {
      const now = Date.now();
      const week = 7 * 24 * 60 * 60 * 1000;
      let target = this.anchor;
      if (this.weekly && target <= now) {
        target += Math.ceil((now - target + 1) / week) * week;
      }
      const remaining = Math.max(0, target - now);
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      this.querySelector('[data-restock-days]').textContent = days;
      this.querySelector('[data-restock-hours]').textContent = hours;
      this.querySelector('[data-restock-minutes]').textContent = minutes;
      this.querySelector('[data-restock-seconds]').textContent = seconds;
      this.querySelector('[data-restock-accessible]').textContent = `${days} days, ${hours} hours, ${minutes} minutes and ${seconds} seconds until restock`;
    }
  });
}
